import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { IEntityCategoryFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../../ActionsVisibilityContext';
import CategoriesPopover from '../CategoriesPopover';
import EntityCategoriesList from './EntityCategoriesList';
import ApplyTagsAction from './ApplyTagsAction';

interface IProps {
  schemaId: string;
  entityCategories: IEntityCategoryFieldsFragment[];
  onApply?: (selectedCategories: string[], isManaged: boolean) => Promise<void>;
  isPermittedToCreateCategory: boolean;
  isManaged?: boolean;
}

const Container = styled.div`
  display: flex;
  column-gap: 8px;
  row-gap: 4px;
  width: auto;
`;

const EntityCategories = ({
  schemaId,
  entityCategories,
  onApply,
  isPermittedToCreateCategory,
  isManaged,
}: IProps) => {
  const anchorEl = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const { actionsVisible, showActions, hideActions, blurActions } =
    useActionsVisibilityContext();

  const onComplete = async (
    selectedCategories: string[],
    isManaged: boolean,
  ) => {
    await onApply?.(selectedCategories, isManaged);
    setOpen(false);
  };

  const showCreateAction = isPermittedToCreateCategory && actionsVisible;

  const onOpenTagEditor = () => {
    setOpen(true);
    hideActions();
  };

  return (
    <>
      <Container
        ref={anchorEl}
        onMouseEnter={showActions}
        onMouseLeave={hideActions}
        onBlur={blurActions}
      >
        <EntityCategoriesList
          entityCategories={entityCategories}
          onClick={onOpenTagEditor}
          isManaged={isManaged}
        />
        <ApplyTagsAction
          onClick={onOpenTagEditor}
          hidden={!showCreateAction}
          showPlaceholder={!entityCategories.length && !isManaged}
        />
      </Container>
      {open && (
        <CategoriesPopover
          schemaId={schemaId}
          anchorEl={anchorEl}
          isOpen
          onClose={() => setOpen(false)}
          onApply={onComplete}
          entityCategories={entityCategories}
          isManaged={isManaged}
        />
      )}
    </>
  );
};

export default withActionsVisibilityContext(EntityCategories);
